export const SLICE_NAME = "vtn";

const GET_VTN = `${SLICE_NAME}/GET_VTN`;
const UPDATE_VTN = `${SLICE_NAME}/UPDATE_VTN`;

export const actionTypes = {
  GET_VTN,
  UPDATE_VTN,
};
